import {inject, Injectable} from '@angular/core';
import {LeadSaveResponse} from '../../models/lead.model';
import {SessionStorageService} from '../session-storage/session-storage.service';
import {SessionStorageNames} from '../../enums/session-storage-names.enum';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() {}

  storeSaveData(res: LeadSaveResponse) {
    if (!res?.id) return;
    this.sessionStorageService.set(SessionStorageNames.LEAD_ID, res.id);
  }

  getSaveId() {
    return this.sessionStorageService.get(SessionStorageNames.LEAD_ID);
  }
}
